import { Link } from 'react-router-dom';
import { Package, Phone, Mail, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {/* Footer Content - Properly Centered */}
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-y-12 md:gap-x-20">
            {/* Brand */}
            <div className="col-span-1 md:col-span-1 text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start space-x-2 mb-6">
                <Package className="h-8 w-8 text-accent-500" />
                <span className="text-xl font-bold text-white">TUMANASI</span>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed mx-auto md:mx-0 max-w-[240px]">
                Your Partner in Sending Easy. Fast, safe, photo-verified delivery across Nairobi.
              </p>
            </div>

            {/* Quick Links */}
            <div className="text-center md:text-left">
              <h3 className="text-white font-bold mb-6 text-base">Quick Links</h3>
              <ul className="space-y-4 text-sm">
                <li>
                  <Link to="/" className="text-gray-400 hover:text-accent-500 transition-colors duration-200 inline-block">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/pricing" className="text-gray-400 hover:text-accent-500 transition-colors duration-200 inline-block">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link to="/book" className="text-gray-400 hover:text-accent-500 transition-colors duration-200 inline-block">
                    Book Delivery
                  </Link>
                </li>
                <li>
                  <Link to="/track" className="text-gray-400 hover:text-accent-500 transition-colors duration-200 inline-block">
                    Track Delivery
                  </Link>
                </li>
                <li>
                  <Link to="/rider/register" className="text-gray-400 hover:text-accent-500 transition-colors duration-200 inline-block">
                    Become a Rider
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="text-center md:text-left">
              <h3 className="text-white font-bold mb-6 text-base">Contact</h3>
              <ul className="space-y-4 text-sm">
                <li className="flex items-center justify-center md:justify-start gap-3">
                  <Phone size={16} className="text-accent-500 flex-shrink-0" />
                  <a href="tel:0118687088" className="text-gray-400 hover:text-accent-500 transition-colors duration-200">
                    0118 687 088
                  </a>
                </li>
                <li className="flex items-center justify-center md:justify-start gap-3">
                  <Phone size={16} className="text-accent-500 flex-shrink-0" />
                  <a href="tel:0784008487" className="text-gray-400 hover:text-accent-500 transition-colors duration-200">
                    0784 008 487
                  </a>
                </li>
                <li className="flex items-center justify-center md:justify-start gap-3">
                  <Mail size={16} className="text-accent-500 flex-shrink-0" />
                  <a href="mailto:info@tumanasi.co.ke" className="text-gray-400 hover:text-accent-500 transition-colors duration-200">
                    info@tumanasi.co.ke
                  </a>
                </li>
                <li className="flex items-start justify-center md:justify-start gap-3">
                  <MapPin size={16} className="text-accent-500 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-400">Nairobi, Kenya</span>
                </li>
              </ul>
            </div>

            {/* Hours */}
            <div className="text-center md:text-left">
              <h3 className="text-white font-bold mb-6 text-base">Service Hours</h3>
              <ul className="space-y-4 text-sm">
                <li className="text-gray-400">Monday - Friday: 7am - 7pm</li>
                <li className="text-gray-400">Saturday: 8am - 6pm</li>
                <li className="text-gray-400">Sunday: 9am - 5pm</li>
                <li className="text-accent-500 font-semibold mt-6 pt-5 border-t border-gray-800">
                  Same-day delivery available
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright - Centered */}
        <div className="border-t border-gray-800 mt-20 pt-10 text-center">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Tumanasi. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
